import { render, staticRenderFns } from "./RequestPricePlaceOrders.vue?vue&type=template&id=136c5a93&"
import script from "./RequestPricePlaceOrders.vue?vue&type=script&lang=js&"
export * from "./RequestPricePlaceOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports